// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-color path {
    stroke: #ffffff;
}
ul > li.ant-menu-item-active:hover {
    color: #61b5ff !important;
    stroke: #61b5ff !important;
}

ul > li.ant-menu-item-active:hover .icon-color path {
    stroke: #61b5ff;
}

.gk-menu.ant-menu-light {
    background-color: #003c71 !important;
}

.gk-menu.ant-menu-light .ant-menu-submenu {
    background-color: #003c71 !important;
}

.gk-menu.ant-menu-light .ant-menu-submenu-vertical .ant-menu-submenu-title {
    padding-right: 8px !important;
    padding-left: 8px !important;
    padding-top: 7px !important;
}

.gk-menu.ant-menu-light .ant-menu-submenu-title:hover {
    color: #61b5ff !important;
    stroke: #61b5ff !important;
    .icon-color path {
        stroke: #61b5ff !important;
    }
    .ant-menu-submenu-arrow::before,
    .ant-menu-submenu-arrow::after {
        background: #61b5ff !important;
    }
}

.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-sub .ant-menu-item.ant-menu-item-selected {
    color: #61b5ff !important;
    stroke: #61b5ff !important;
    .icon-color path {
        stroke: #61b5ff !important;
    }
}

.gk-menu.ant-menu-light .ant-menu-submenu.ant-menu-submenu-selected .ant-menu-submenu-title {
    color: #61b5ff !important;
    stroke: #61b5ff !important;
    .icon-color path {
        stroke: #61b5ff !important;
    }
}

.gk-menu.ant-menu-item {
    background-color: #003c71 !important;
}

.gk-menu.ant-menu-light .ant-menu-item {
    background-color: #003c71 !important;
}

.gk-menu.ant-menu-light .ant-menu-item-selected {
    color: #61b5ff !important;
    stroke: #61b5ff !important;
    .icon-color path {
        stroke: #61b5ff !important;
    }
}

.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item {
    background-color: #003c71 !important;
    padding-left: 4px !important;
    padding-top: 4px !important;
    margin: 0 !important;
    color: white !important;
    stroke: white !important;
    margin-block: 0 !important;
    margin-inline: 0 !important;
    border-radius: 0 !important;
    width: 100% !important;
    .icon-color path {
        stroke: white !important;
    }

    font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif, center !important;
}

.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-title-content {
    position: absolute !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    left: 30px;
}
.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item-selected {
    color: #61b5ff !important;
    stroke: #61b5ff !important;
    .icon-color path {
        stroke: #61b5ff !important;
    }
}
.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item-active:hover {
    color: #61b5ff !important;
    stroke: #61b5ff !important;
    .icon-color path {
        stroke: #61b5ff !important;
    }
}
.ant-menu-item-icon {
    width: 1.5rem;
    max-width: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/library/components/common/sideNav/styles.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B;QACI,0BAA0B;IAC9B;IACA;;QAEI,8BAA8B;IAClC;AACJ;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,oCAAoC;IACpC,4BAA4B;IAC5B,2BAA2B;IAC3B,oBAAoB;IACpB,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,sBAAsB;IACtB;QACI,wBAAwB;IAC5B;;IAEA,8EAA8E;AAClF;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;AACd;AACA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B;QACI,0BAA0B;IAC9B;AACJ;AACA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B;QACI,0BAA0B;IAC9B;AACJ;AACA;IACI,aAAa;IACb,iBAAiB;AACrB","sourcesContent":[".icon-color path {\n    stroke: #ffffff;\n}\nul > li.ant-menu-item-active:hover {\n    color: #61b5ff !important;\n    stroke: #61b5ff !important;\n}\n\nul > li.ant-menu-item-active:hover .icon-color path {\n    stroke: #61b5ff;\n}\n\n.gk-menu.ant-menu-light {\n    background-color: #003c71 !important;\n}\n\n.gk-menu.ant-menu-light .ant-menu-submenu {\n    background-color: #003c71 !important;\n}\n\n.gk-menu.ant-menu-light .ant-menu-submenu-vertical .ant-menu-submenu-title {\n    padding-right: 8px !important;\n    padding-left: 8px !important;\n    padding-top: 7px !important;\n}\n\n.gk-menu.ant-menu-light .ant-menu-submenu-title:hover {\n    color: #61b5ff !important;\n    stroke: #61b5ff !important;\n    .icon-color path {\n        stroke: #61b5ff !important;\n    }\n    .ant-menu-submenu-arrow::before,\n    .ant-menu-submenu-arrow::after {\n        background: #61b5ff !important;\n    }\n}\n\n.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-sub .ant-menu-item.ant-menu-item-selected {\n    color: #61b5ff !important;\n    stroke: #61b5ff !important;\n    .icon-color path {\n        stroke: #61b5ff !important;\n    }\n}\n\n.gk-menu.ant-menu-light .ant-menu-submenu.ant-menu-submenu-selected .ant-menu-submenu-title {\n    color: #61b5ff !important;\n    stroke: #61b5ff !important;\n    .icon-color path {\n        stroke: #61b5ff !important;\n    }\n}\n\n.gk-menu.ant-menu-item {\n    background-color: #003c71 !important;\n}\n\n.gk-menu.ant-menu-light .ant-menu-item {\n    background-color: #003c71 !important;\n}\n\n.gk-menu.ant-menu-light .ant-menu-item-selected {\n    color: #61b5ff !important;\n    stroke: #61b5ff !important;\n    .icon-color path {\n        stroke: #61b5ff !important;\n    }\n}\n\n.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item {\n    background-color: #003c71 !important;\n    padding-left: 4px !important;\n    padding-top: 4px !important;\n    margin: 0 !important;\n    color: white !important;\n    stroke: white !important;\n    margin-block: 0 !important;\n    margin-inline: 0 !important;\n    border-radius: 0 !important;\n    width: 100% !important;\n    .icon-color path {\n        stroke: white !important;\n    }\n\n    font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif, center !important;\n}\n\n.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-title-content {\n    position: absolute !important;\n    top: 0 !important;\n    right: 0 !important;\n    bottom: 0 !important;\n    left: 30px;\n}\n.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item-selected {\n    color: #61b5ff !important;\n    stroke: #61b5ff !important;\n    .icon-color path {\n        stroke: #61b5ff !important;\n    }\n}\n.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item-active:hover {\n    color: #61b5ff !important;\n    stroke: #61b5ff !important;\n    .icon-color path {\n        stroke: #61b5ff !important;\n    }\n}\n.ant-menu-item-icon {\n    width: 1.5rem;\n    max-width: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
